<ng-template #content let-modal>
  <div class="tw-p-4 tw-shadow-lg" ngbAutoFocus>
    @if (data(); as data) {
      <div class="tw-flex tw-flex-col tw-gap-3">
        <div class="tw-text-lg tw-font-bold">Chuyến bay hết chỗ</div>
        @if (isSoldOut()) {
          <div>
            Chuyến bay bạn chọn đã hết chỗ, vui lòng chọn lại chuyến bay khác.
          </div>
        } @else {
          <div>
            Chuyến bay bạn chọn đã hết chỗ, vui lòng chọn hạng ghế cao hơn để
            tiếp tục.
          </div>

          @if (data.selectedFlightGroup; as selectedFlightGroup) {
            <div>
              <div class="tw-font-bold tw-text-secondary">Chiều đi:</div>
              <div
                class="tw-flex tw-max-h-[12.5rem] tw-flex-col tw-gap-1 tw-overflow-auto"
              >
                @for (
                  item of selectedFlightGroup.flights;
                  track $index + "-" + item.fareDataId
                ) {
                  <app-fare-reselect
                    [item]="item"
                    (selected)="onSelectFlight($event)"
                    [isSelecting]="checkSelectingFlight(item)"
                    [disabled]="checkDisabledFlight(item)"
                  ></app-fare-reselect>
                }
              </div>
            </div>
          }

          @if (
            data.selectedRoundTripFlightGroup;
            as selectedRoundTripFlightGroup
          ) {
            <div>
              <div class="tw-font-bold tw-text-secondary">Chiều về:</div>
              <div
                class="tw-flex tw-max-h-[12.5rem] tw-flex-col tw-gap-1 tw-overflow-auto"
              >
                @for (
                  item of selectedRoundTripFlightGroup.flights;
                  track $index + "-" + item.fareDataId
                ) {
                  <app-fare-reselect
                    [item]="item"
                    (selected)="onSelectFlight($event)"
                    [isSelecting]="checkSelectingFlight(item)"
                    [disabled]="checkDisabledFlight(item)"
                  ></app-fare-reselect>
                }
              </div>
            </div>
          }
        }

        @if (isSoldOut()) {
          <div class="tw-flex tw-gap-2">
            <button
              type="button"
              class="tw-w-full tw-rounded-lg tw-bg-secondary tw-px-3 tw-py-1.5 tw-text-base tw-font-bold tw-text-secondary-content tw-transition-all focus:tw-ring-4 active:tw-opacity-80 disabled:tw-pointer-events-none disabled:tw-opacity-50"
              (click)="onCancel(modal)"
            >
              Đồng ý
            </button>
          </div>
        } @else {
          <div class="tw-flex tw-gap-2">
            <button
              type="button"
              class="tw-w-full tw-rounded-lg tw-bg-gray-300 tw-px-3 tw-py-1.5 tw-font-bold tw-text-base-700 tw-transition-all focus:tw-ring-4 focus:tw-ring-gray-200 active:tw-opacity-80"
              (click)="onCancel(modal)"
            >
              Từ chối
            </button>
            <button
              type="button"
              class="tw-w-full tw-rounded-lg tw-bg-secondary tw-px-3 tw-py-1.5 tw-text-base tw-font-bold tw-text-secondary-content tw-transition-all focus:tw-ring-4 active:tw-opacity-80 disabled:tw-pointer-events-none disabled:tw-opacity-50"
              (click)="onReselect(modal)"
              [disabled]="!isAllowReselect()"
            >
              Đồng ý
            </button>
          </div>
        }
      </div>
    }
  </div>
</ng-template>
